<script>
import CardComponent from '@/components/CardComponent'
import HeroBar from '@/components/HeroBar'
import { Pie } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js'
import moment from 'moment'
import debounce from 'lodash/debounce'
import $ from 'jquery'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'Dashboard',
  components: {
    CardComponent,
    HeroBar,
    Pie,
  },
  data () {
    return {
      params: {
        car_id: null,
        driver_id: null,
        request_unit_id: null,
        transfer_date_range: [],
      },

      vehicles: [],
      vehiclesFetching: false,

      drivers: [],
      driversFetching: false,

      requestUnits: [],
      requestUnitsFetching: false,

      transferDateRange: [],

      hasData: false,
      chartLoading: true,

      chartData: {
        labels: ['Yolda', 'Tamamlanan', 'İptal Edilen'],
        datasets: [{
          backgroundColor: ['#209cee', '#7957d5', '#ff3860'],
          data: [0, 0, 0],
        }]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            labels: {
              font: {
                family: 'Nunito',
                size: 16,
              },
            },
          },
          title: {
            display: true,
            text: 'Taşıt Görev Sayıları',
            font: {
              family: 'Nunito',
              size: 16,
            },
          }
        },
      },
    }
  },
  created () {
    this.loadChart()
  },
  mounted () {
    $('.datepicker').on('click', '.icon.is-right.is-clickable .mdi-close-circle', () => {
      this.params.transfer_date_range = []
      this.transferDateRange = []
      this.loadChart()
      setTimeout(() => this.$refs.datepicker.toggle())
    })
  },
  methods: {
    loadChart () {
      this.chartLoading = true
      this.$http
        .get('/dashboard', { params: this.params })
        .then(({ data }) => {
          const values = Object.values(data)
          this.chartData.datasets[0].data = values
          this.hasData = !values.every(value => value === 0)
        })
        .finally(() => {
          this.chartLoading = false
        })
    },
    fetchVehicles: debounce(function (plate) {
      if (!plate.trim().length) {
        return
      }

      this.vehiclesFetching = true

      this.$http
        .get('/list-all-cars', { params: { plate } })
        .then(({ data }) => {
          this.vehicles = data.data
        })
        .finally(() => {
          this.vehiclesFetching = false
        })
    }, 800),
    selectVehicle (vehicle) {
      this.params.car_id = vehicle?.id || null
      this.loadChart()
    },
    fetchDrivers: debounce(function (name) {
      if (!name.trim().length) {
        return
      }

      this.driversFetching = true

      this.$http
        .get('/drivers', { params: { name } })
        .then(({ data }) => {
          this.drivers = data.data
        })
        .finally(() => {
          this.driversFetching = false
        })
    }, 800),
    selectDriver (driver) {
      this.params.driver_id = driver?.id || null
      this.loadChart()
    },
    fetchRequestUnits: debounce(function (name) {
      if (!name.trim().length) {
        return
      }

      this.requestUnitsFetching = true

      this.$http
        .get('/specifications', { params: { type: 2, name } })
        .then(({ data }) => {
          this.requestUnits = data.data
        })
        .finally(() => {
          this.requestUnitsFetching = false
        })
    }, 800),
    selectRequestUnit (requestUnit) {
      this.params.request_unit_id = requestUnit?.id || null
      this.loadChart()
    },
    formatDateRange (dates) {
      if (dates.length === 2) {
        return new Intl.DateTimeFormat('tr-TR').format(dates[0]) + ' - ' + new Intl.DateTimeFormat('tr-TR').format(dates[1])
      }
    },
    selectDateRange (dateRange) {
      this.params.transfer_date_range = dateRange.map((date) => moment(date).format('YYYY-MM-DD'))
      this.loadChart()
    },
  },
}
</script>

<template>
  <div class="content-area">
    <hero-bar>Dashboard</hero-bar>
    <section class="section is-main-section">
      <card-component>
        <b-collapse class="card" animation="slide" aria-id="filters" :open="false">
          <template #trigger="props">
            <div class="card-header" role="button" aria-controls="filters" :aria-expanded="props.open">
              <p class="card-header-title">Filtreler</p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'chevron-down' : 'chevron-up'" />
              </a>
            </div>
          </template>
          <div class="card-content">
            <div class="content">
              <b-field horizontal label="Araç" class="no-wrap">
                <b-autocomplete
                  :data="vehicles"
                  :loading="vehiclesFetching"
                  field="plate"
                  placeholder="Araç plakası giriniz"
                  icon="magnify"
                  clearable
                  @typing="fetchVehicles"
                  @select="selectVehicle"
                >
                  <template slot-scope="props">
                    {{ props.option.plate }}
                    <span class="emptyText">
                      ({{ props.option.brand }} - {{ props.option.model }})
                      <br>
                      <small>{{ props.option.vehicle_type ? props.option.vehicle_type.name : '-' }}</small>
                    </span>
                  </template>
                  <template #empty>
                    {{ vehiclesFetching ? 'Yükleniyor...' : 'Eşleşen plaka bulunamadı.' }}
                  </template>
                </b-autocomplete>
              </b-field>
              <b-field horizontal label="Sürücü" class="no-wrap">
                <b-autocomplete
                  :data="drivers"
                  :loading="driversFetching"
                  field="name"
                  placeholder="Sürücü ismi giriniz"
                  icon="magnify"
                  clearable
                  @typing="fetchDrivers"
                  @select="selectDriver"
                >
                  <template slot-scope="props">
                    <div class="media">
                      <div class="media-content">
                        <b>{{ props.option.name }}</b>
                        <br>
                        <small>
                          {{ props.option.phone | phone }}
                        </small>
                      </div>
                    </div>
                  </template>
                  <template #empty>
                    {{ driversFetching ? 'Yükleniyor...' : 'Eşleşen sürücü bulunamadı.' }}
                  </template>
                </b-autocomplete>
              </b-field>
              <b-field horizontal label="Talep Eden Birim" class="no-wrap">
                <b-autocomplete
                  :data="requestUnits"
                  :loading="requestUnitsFetching"
                  field="name"
                  placeholder="Talep eden birim adı giriniz"
                  icon="magnify"
                  clearable
                  @typing="fetchRequestUnits"
                  @select="selectRequestUnit"
                >
                  <template #empty>
                    {{ requestUnitsFetching ? 'Yükleniyor...' : 'Eşleşen birim bulunamadı.' }}
                  </template>
                </b-autocomplete>
              </b-field>
              <b-field horizontal label="Tarih Aralığı" class="no-wrap">
                <b-datepicker
                  ref="datepicker"
                  v-model="transferDateRange"
                  :first-day-of-week="1"
                  :month-names="$t('dateTimePicker.monthNames')"
                  :day-names="$t('dateTimePicker.dayNames')"
                  :min-date="new Date(new Date().getFullYear() - 1, 0, 1)"
                  :max-date="new Date()"
                  :date-formatter="formatDateRange"
                  icon="calendar-today"
                  :icon-right="transferDateRange.length === 2 ? 'close-circle' : ''"
                  icon-right-clickable
                  trap-focus
                  placeholder="Tarih aralığı seçiniz"
                  range
                  @input="selectDateRange"
                />
              </b-field>
            </div>
          </div>
        </b-collapse>

        <div class="mt-4">
          <b-loading :active="chartLoading" :is-full-page="false" />
          <div v-if="!hasData && !chartLoading" class="has-text-centered has-text-danger">
            Arama kriterlerinize uygun kayıt bulunamadı.
          </div>
          <Pie
            :chart-options="chartOptions"
            :chart-data="chartData"
            chart-id="pie-chart"
            dataset-id-key="label"
            :width="500"
            :height="500"
          />
        </div>
      </card-component>
    </section>
  </div>
</template>
